module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel04_1280_1280_en-1943d73a79cd5be1f0de9267341b1a28.jpg";